
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11416",
                "data-name": "矩形 11416",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(-0.3 0)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_353",
        "data-name": "蒙版组 353",
        "class": "cls-2",
        "transform": "translate(0.3 0)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "xiyiji",
            "transform": "translate(3.6 2.4)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7774",
                "data-name": "路径 7774",
                "class": "cls-3",
                "d": "M85.292,0H71.145a1.294,1.294,0,0,0-1.326,1.309V17.018a1.294,1.294,0,0,0,1.326,1.309h.442v.436a.415.415,0,0,0,.442.436H73.8a.415.415,0,0,0,.442-.436v-.436H82.2v.436a.415.415,0,0,0,.442.436h1.768a.415.415,0,0,0,.442-.436v-.436h.442a1.294,1.294,0,0,0,1.326-1.309V1.309A1.294,1.294,0,0,0,85.292,0ZM71.145.873H85.292a.415.415,0,0,1,.442.436V3.491H70.7V1.309A.415.415,0,0,1,71.145.873ZM85.292,17.455H71.145a.415.415,0,0,1-.442-.436V4.364H85.734V17.018A.415.415,0,0,1,85.292,17.455Z",
                "transform": "translate(-69.818 0)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7775",
                "data-name": "路径 7775",
                "class": "cls-3",
                "d": "M169.541,97.891a4.364,4.364,0,1,0,4.421,4.364A4.406,4.406,0,0,0,169.541,97.891Zm0,7.855a3.491,3.491,0,1,1,3.537-3.491A3.524,3.524,0,0,1,169.541,105.745Zm5.305-11.782h.884a.436.436,0,1,0,0-.873h-.884a.436.436,0,1,0,0,.873Zm-11.495,0h.442a.436.436,0,1,0,0-.873h-.442a.436.436,0,1,0,0,.873Zm2.211,0H166a.436.436,0,1,0,0-.873h-.442a.436.436,0,1,0,0,.873Z",
                "transform": "translate(-161.141 -91.345)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7776",
                "data-name": "路径 7776",
                "class": "cls-3",
                "d": "M350.483,535.8a1.986,1.986,0,0,1-1.149.349,1.81,1.81,0,0,1-1.15-.393.438.438,0,0,0-.619.131.426.426,0,0,0,.133.611,2.71,2.71,0,0,0,1.592.524,2.439,2.439,0,0,0,1.592-.524,2.006,2.006,0,0,1,2.122-.087.48.48,0,0,0,.619-.131.466.466,0,0,0-.133-.611,2.724,2.724,0,0,0-1.415-.393A2.439,2.439,0,0,0,350.483,535.8Z",
                "transform": "translate(-342.216 -525.236)"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  